exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-f4708312]{text-align:center;font-size:25px;background:rgba(0,0,0,.06);border-bottom:1px solid #000}.body[data-v-f4708312]{line-height:50px;font-size:20px;overflow:hidden}.body-title[data-v-f4708312]{width:125px;float:left;height:40px}.body-content[data-v-f4708312]{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-f4708312","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/patientInfo.vue
// module id = 5Kf4
// module chunks = 0